import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../../commonFunctions";
  
  const ctinf = {
    label: "CTR Information",
    pageLabel: "CTR Information",
    starting: true,
    url: "ctinf",
    pageType: "history",
    form: [
        {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "ReRegistration No.",
            name: "",
            description: "Enter ReRegistration No"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: " ReRegistration No",
            name: "ReRegistration_No",
            description: "Enter ReRegistration No"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "CKYC FI Code",
            name: "",
            description: "Enter CKYC FI Code"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: " CKYC FI Code",
            name: "CKYC_FI_Code",
            description: "Enter CKYC FI Code"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "FLURID",
            name: "",
            description: "Enter FLURID"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "FLURID",
            name: "FLURID",
            description: "Enter FLURID"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "CKYC FI Name",
            name: "",
            description: "Enter CKYC FI Name"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: " CKYC FI Name",
            name: "CKYC_FI_Name",
            description: "Enter CKYC FI Name"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "PO Name",
            name: "",
            description: "Enter PO Name"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "PO Name",
            name: "PO_Name",
            description: "Enter PO_Name"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "CKYC Upload By User ",
            name: "",
            description: "Enter CKYC Upload By User "
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: " CKYC Upload By User ",
            name: "CKYC_UploadBy_User ",
            description: "Enter CKYC Upload By User "
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "PO Designation",
            name: "",
            description: "Enter PO Designation"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "PO Designation",
            name: "PO_Designation",
            description: "Enter PO Designation"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "CKYC Place",
            name: "",
            description: "Enter CKYC Place"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: " CKYC Place",
            name: "CKYC_Place",
            description: "Enter CKYC Place"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Address",
            name: "",
            description: "Enter Address"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Address",
            name: "Address",
            description: "Enter Address"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "CKYC URL",
            name: "",
            description: "Enter CKYC URL"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: " CKYC URL",
            name: "CKYC_URL",
            description: "Enter CKYC URL"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "City",
            name: "",
            description: "Enter City"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "City",
            name: "City",
            description: "Enter City"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "StateCode",
            name: "",
            description: "Enter StateCode"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "StateCode",
            name: "StateCode",
            description: "Enter StateCode"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Sign/Photo URL",
            name: "",
            description: "Enter Sign/Photo URL"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Sign/Photo URL",
            name: "Sign_Photo_URL",
            description: "Enter Sign/Photo URL"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "PinCode",
            name: "",
            description: "Enter PinCode"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "PinCode",
            name: "PinCode",
            description: "Enter PinCode"
          },

          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "ATM Recon Bank Code",
            name: "",
            description: "Enter ATM Recon Bank Code"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "ATM Recon Bank Code",
            name: "ATMReconBankCode",
            description: "Enter ATM Recon Bank Code"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Phone",
            name: "",
            description: "Enter Phone"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Phone",
            name: "Phone",
            description: "Enter Phone"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "ACH-BankCode",
            name: "",
            description: "Enter ACH-BankCode"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "ACH-BankCode",
            name: "ACH_BankCode",
            description: "Enter ACH-BankCode"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Mobile",
            name: "",
            description: "Enter Mobile"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Mobile",
            name: "Mobile",
            description: "Enter Mobile"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "APB-BankCode",
            name: "",
            description: "Enter APB-BankCode"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "APB-BankCode",
            name: "APB_BankCode",
            description: "Enter APB-BankCode"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Fax",
            name: "",
            description: "Enter Fax"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Fax",
            name: "Fax",
            description: "Enter Fax"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "APB User Code",
            name: "",
            description: "Enter APB User Code"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "APB User Code",
            name: "APB_UserCode",
            description: "Enter APB User Code"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "PO Email",
            name: "",
            description: "Enter PO Email"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "PO Email",
            name: "PO_Email",
            description: "Enter PO Email"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "APB Mapp File No",
            name: "",
            description: "Enter APB Mapp File No"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "APB Mapp File No",
            name: "APB_MappFileNo",
            description: "Enter APB Mapp File No"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Entity Category",
            name: "",
            description: "Enter Entity Category"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Entity Category",
            name: "Entity_Category",
            description: "Enter Entity Category"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "IIN",
            name: "",
            description: "Enter IIN"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "IIN",
            name: "IIN",
            description: "Enter IIN"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "CIBIL ReportMemberCode",
            name: "",
            description: "Enter CIBIL ReportMemberCode"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "CIBIL ReportMemberCode",
            name: "CIBIL_ReportMemberCode",
            description: "Enter CIBIL ReportMemberCode"
          }, {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "CTR Batch Number",
            name: "",
            description: "Enter CTR Batch Number"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "CTR Batch Number",
            name: "CTR_Batch_Number",
            description: "Enter CTR Batch Number"
          }, {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "CIBIL MemberShortName",
            name: "",
            description: "Enter CIBIL MemberShortName"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "CIBIL MemberShortName",
            name: "CIBIL_MemberShortName",
            description: "Enter CIBIL MemberShortName"
          },

    ]
}

export default ctinf;